module.exports = __webpack_public_path__ + "img/MK_Screen_2.c3930a2e.jpg";